import { FC, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Alert, Spin, Typography } from 'antd';
import { FormattedMessage } from 'react-intl';

import AuthPage from 'modules/auth/components/AuthPage';
import { Logo } from 'modules/ui';
import config from 'config';

import { verifyMagicLink } from '../../api';
import { useGuestAuth } from '../../GuestAuthContext';
import { getGuestMagicLinkParams } from '../../utils';

const { Paragraph } = Typography;

const GuestVerifyPage: FC = () => {
    const { search } = useLocation();
    const history = useHistory();
    const { loginGuest } = useGuestAuth();
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const { token, isGuest } = getGuestMagicLinkParams(search);
        if (!isGuest || !token) {
            setError('guest.verify.missingToken');
            return;
        }

        let cancelled = false;
        verifyMagicLink(token)
            .then(({ accessToken, customer }) => {
                if (cancelled) return;
                loginGuest(accessToken, customer);
                history.replace(config.routes.guestDocuments);
            })
            .catch(() => {
                if (!cancelled) setError('guest.verify.error');
            });

        return () => { cancelled = true; };
    }, [search, loginGuest, history]);

    return (
        <AuthPage>
            <div style={{ width: '100%', padding: '2rem 1rem 3rem', textAlign: 'center' }}>
                <div style={{ width: 300, height: 70, marginBottom: '2rem' }}><Logo /></div>

                {error ? (
                    <Alert
                        type="error"
                        message={<FormattedMessage id={error} />}
                        showIcon
                    />
                ) : (
                    <>
                        <Spin size="large" />
                        <Paragraph style={{ marginTop: '1rem' }}>
                            <FormattedMessage id="guest.verify.loading" />
                        </Paragraph>
                    </>
                )}
            </div>
        </AuthPage>
    );
};

export default GuestVerifyPage;
